import { StyleSheet } from '@react-pdf/renderer';

const actaPDFStyles = StyleSheet.create({
  page: {
    padding: 30,
    fontSize: 12,
    fontFamily: 'Helvetica',
    backgroundColor: '#ffffff',
    color: '#1e293b'
  },
  section: {
    marginBottom: 15,
    padding: '0 10px'
  },
  headerTable: {
    display: 'flex',
    width: '100%',
    borderStyle: 'solid',
    borderWidth: 1.5,
    borderColor: '#334155',
    marginBottom: 25
  },
  headerRow: {
    flexDirection: 'row',
    borderBottomWidth: 1.5,
    borderBottomColor: '#334155',
    borderBottomStyle: 'solid',
    backgroundColor: '#f8fafc'
  },
  headerCell: {
    padding: 8,
    borderRightWidth: 1,
    borderRightColor: '#334155',
    borderRightStyle: 'solid',
    display: 'flex'
  },
  logo: {
    width: 110,
    height: 90,
    objectFit: 'contain',
    margin: '10px auto'
  },
  headerText: {
    fontSize: 11,
    color: '#444444',
    textAlign: 'center',
    fontWeight: 'bold',
    letterSpacing: 0.5
  },
  sectionTitle: {
    backgroundColor: '#f1f5f9',
    padding: 8,
    marginBottom: 12,
    fontWeight: 'bold',
    color: '#444444',
    textAlign: 'center',
    borderRadius: 4
  },
  table: {
    display: 'flex',
    width: '100%',
    borderStyle: 'solid',
    borderWidth: 1.5,
    borderColor: '#334155',
    marginTop: 10,
    marginBottom: 20
  },
  tableRow: {
    flexDirection: 'row',
    borderBottomWidth: 1,
    borderBottomColor: '#e2e8f0',
    borderBottomStyle: 'solid'
  },
  tableCell: {
    padding: 6,
    fontSize: 10,
    color: '#1e293b',
    textAlign: 'center'
  },
  pageNumber: {
    position: 'absolute',
    fontSize: 8,
    bottom: 20,
    left: 0,
    right: 0,
    textAlign: 'center',
    color: '#64748b'
  },
  // Estilos específicos para fecha, lugar y responsable
  dateTimeRow: {
    flexDirection: 'row',
    borderBottomWidth: 1, 
    borderBottomColor: '#000000',
    borderBottomStyle: 'solid'
  },
  dateTimeCell: {
    padding: 8,
    borderRightWidth: 1, 
    borderRightColor: '#000000',
    borderRightStyle: 'solid',
    display: 'flex',
    flexDirection: 'row'
  },
  dateTimeCellLast: {
    padding: 8,
    display: 'flex',
    flexDirection: 'row'
  },
  singleRowCell: {
    padding: 8,
    display: 'flex',
    flexDirection: 'row'
  },
  // Estilos para la tabla de información
  infoTable: {
    display: 'flex',
    width: '100%',
    borderStyle: 'solid',
    borderWidth: 1.5,
    borderColor: '#334155',
    marginBottom: 20,
  },
  infoRow: {
    flexDirection: 'row',
    borderBottomWidth: 1,
    borderBottomColor: '#000000',
    borderBottomStyle: 'solid',
  },
  infoRowLast: {
    flexDirection: 'row',
  },
  infoCell: {
    padding: 8,
    borderRightWidth: 1,
    borderRightColor: '#000000',
    borderRightStyle: 'solid',
    width: '50%',
  },
  infoCellLast: {
    padding: 8,
    width: '50%',
  },
  infoLabel: {
    fontSize: 10,
    fontWeight: 'bold',
  },
  tipoActaRow: {
    flexDirection: 'row'
  },
  // Estilos para el contenedor de objetivo
  objectiveContainer: {
    marginBottom: 20,
    borderStyle: 'solid',
    borderWidth: 1.5,
    borderColor: '#334155',
  },
  objectiveHeader: {
    backgroundColor: '#f1f5f9',
    padding: 8,
    fontWeight: 'bold',
    color: '#1e293b',
    textAlign: 'center',
  },
  objectiveContent: {
    padding: 10,
  },
  objectiveParagraph: {
    fontSize: 9.5,
    lineHeight: 1.4,
    color: '#1e293b',
    marginBottom: 6,
  },
  objectiveTableContainer: {
    marginTop: 4,
    marginBottom: 8,
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: '#334155',
  },
  objectiveTableTitle: {
    fontSize: 9,
    fontFamily: 'Helvetica-Bold',
    color: '#1e293b',
    marginBottom: 3,
    marginTop: 4,
  },
  objectiveTableRow: {
    flexDirection: 'row',
    borderBottomWidth: 1,
    borderBottomColor: '#cbd5e1',
    borderBottomStyle: 'solid',
  },
  objectiveTableHeaderCell: {
    padding: 4,
    backgroundColor: '#f1f5f9',
    borderRightWidth: 1,
    borderRightColor: '#cbd5e1',
    borderRightStyle: 'solid',
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
  objectiveTableHeaderText: {
    fontSize: 8,
    fontFamily: 'Helvetica-Bold',
    color: '#1e293b',
    textAlign: 'center',
  },
  objectiveTableCell: {
    padding: 4,
    borderRightWidth: 1,
    borderRightColor: '#cbd5e1',
    borderRightStyle: 'solid',
    flex: 1,
    justifyContent: 'center',
  },
  objectiveCellText: {
    fontSize: 8,
    color: '#334155',
  },
  objectiveCallout: {
    borderLeftWidth: 3,
    borderLeftStyle: 'solid',
    padding: 6,
    marginVertical: 5,
    borderRadius: 2,
  },
  objectiveCalloutTitle: {
    fontSize: 9,
    fontFamily: 'Helvetica-Bold',
    marginBottom: 2,
  },
  objectiveCalloutText: {
    fontSize: 8.5,
    lineHeight: 1.3,
  },
  objectiveBulletRow: {
    flexDirection: 'row',
    marginBottom: 3,
    paddingLeft: 6,
  },
  objectiveBulletDot: {
    width: 12,
    fontSize: 9,
    color: '#475569',
  },
  objectiveBulletText: {
    flex: 1,
    fontSize: 9,
    color: '#1e293b',
  },
  // Estilos para imagen adjunta
  imageContainer: {
    marginBottom: 20,
    borderStyle: 'solid',
    borderWidth: 1.5,
    borderColor: '#334155',
  },
  imageHeader: {
    backgroundColor: '#f1f5f9',
    padding: 8,
    fontWeight: 'bold',
    color: '#1e293b',
    textAlign: 'center',
  },
  imageContent: {
    padding: 10,
    display: 'flex'
  },
  attachedImage: {
    maxWidth: '100%',
    maxHeight: 200,
    objectFit: 'contain',
  },
  // Estilos para columnas de tabla
  tableCol: {
    borderRightWidth: 1,
    borderRightColor: '#e2e8f0',
    borderRightStyle: 'solid',
  },
  // Estilos para el encabezado
  logoCell: {
    width: '25%',
    borderRightWidth: 1,
    borderRightColor: '#334155',
    borderRightStyle: 'solid',
    padding: 5,
  },
  contentColumn: {
    width: '75%',
  },
  contentRow: {
    flexDirection: 'row',
    borderBottomWidth: 1,
    borderBottomColor: '#334155',
    borderBottomStyle: 'solid',
  },
  contentRowLast: {
    flexDirection: 'row',
  },
  contentCell: {
    width: '50%',
    padding: 8,
    borderRightWidth: 1,
    borderRightColor: '#334155',
    borderRightStyle: 'solid',
  },
  contentCellLast: {
    width: '50%',
    padding: 8,
  },
  codeText: {
    fontSize: 10,
    color: '#64748b',
    textAlign: 'center',
  },
  signatureImage: {
    width: 80,
    height: 40,
    objectFit: 'contain',
    margin: '2px auto'
  }
});

export default actaPDFStyles;